import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import actions from '../actions'
import Button from '../../../../Button';
import styles from '../SavedHunt.module.scss';


function NoUserData(props) {
  return (
    <div className={styles.noCollectionsView}>
      <p className={styles.noCollectionsText}>
        Hunts are folders to help you stay organized
      </p>
      <Button
        onClick={props.createCollectionsModal}
        size={Button.SIZE.medium}
        theme={Button.THEME.default}
      >
        Create a Hunt
      </Button>
    </div>
  );
}

NoUserData.propTypes = {
  createCollectionsModal: PropTypes.func,
};

export default connect((model) => {
  return {};
}, actions)(NoUserData)